import React from 'react';
import './../../../Styles/Main/ProfilePage/ProfileOrderBike.scss'

function ProfileOrderBike({...props}) {
   return (
      <div className='bikeOrder__body'>
         <div className="bikeOrder__item text">{props.name}</div>
         <div className="bikeOrder__item text">{props.price} USD</div>
         <div className="bikeOrder__item text">{props.amountDays}</div>
         <div className="bikeOrder__item text">{props.total} USD</div>
      </div>
   );
}
export default ProfileOrderBike;